import { jsx as _jsx } from "react/jsx-runtime";
import XBTOHub from './LogoXBTOHubBlack';
export function AppLogo() {
    return _jsx(XBTOHub, { width: 120, height: 28 });
}
